export interface UserToken {
  access_token: string;
  expires_in: string;
  refresh_token: string;
  scope: string;
  token_type: string;
}

export interface User {
  username: string;
  roles: string[];
  intermediaryId: string;
  accessToken: UserToken;
  branchCode: string;
  userType: string;
}
